export default __webpack_public_path__ + "static/media/trumpet.11bfdb1c.png";